export const CHANNEL_ENGINE_POWERED_FLEXPAY =
  'channel-engine-powered-plan-flexpay';
export const CHANNEL_ENGINE_POWERED_FLEXPAY_RENEWAL =
  'channel-engine-powered-plan-renewal';
export const CHANNEL_ENGINE_POWERED_PLAN = 'channel-engine-powered-plan';
export const CHANNEL_ENGINE_POWERED_PLAN_RENEWAL =
  'channel-engine-powered-plan-renewal-flexpay';
export const CHANNEL_FUNNEL = 'channel-funnel';
export const CHANNEL_NON_FUNNEL = null;
